import React from "react";
import { Button as ChakraButton, ButtonProps } from "@chakra-ui/react";
import Spinner from "./Icon/Spinner";

const Button = ({
  isProcessing = false,
  ...props
}: { isProcessing?: boolean } & ButtonProps) => {
  return (
    <ChakraButton
      colorScheme="brand"
      isDisabled={isProcessing}
      display="flex"
      gap="1rem"
      border={props.variant === undefined ? "1px" : undefined}
      borderColor={props.variant === undefined ? "whiteAlpha.600" : undefined}
      boxShadow={props.variant === undefined ? "md" : undefined}
      leftIcon={isProcessing ? <Spinner /> : props.leftIcon}
      {...props}
    >
      {props.children}
    </ChakraButton>
  );
};

export default Button;
